// Merchandising badge pill (migration 067) — "Most Popular", "Start Here", …
// Rendered above catalog row titles and on the product detail surfaces.
// The Astro catalog page mirrors this markup statically (it can't mount a
// React component without an island) — keep the two in sync via the shared
// class constants in `shared/services/badges.ts`.

import { Star } from '../icons';
import { cn } from '../utils/cn';
import { BADGE_PILL_CLASSES, BADGE_TONE_META, resolveBadgeTone } from '../services/badges';

export interface ServiceBadgeProps {
  label: string;
  /** Palette key; unknown/missing values fall back to gold. */
  tone?: string | null;
  className?: string;
}

export const ServiceBadge = ({ label, tone, className }: ServiceBadgeProps) => {
  const meta = BADGE_TONE_META[resolveBadgeTone(tone)];
  return (
    <span className={cn(BADGE_PILL_CLASSES, meta.classes, className)}>
      {meta.star && <Star className="w-2.5 h-2.5 fill-current" aria-hidden="true" />}
      {label}
    </span>
  );
};
